import React, { useState } from "react";
import { Container, TextField, MenuItem, Button, Grid, Paper, Typography, Box } from "@mui/material";
import SentimentDissatisfiedRoundedIcon from '@mui/icons-material/SentimentDissatisfiedRounded';
import ShowCard from "./ShowCard";
import useReviewHandler from "../hooks/useReviewHandler"; 
import Loader from "../Loader";

const AddReview = ({idToken}) => {
  const [type, setType] = useState("movie");
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null); 
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [reviewLoading, handleReview] = useReviewHandler(idToken);

  const handleSearch = async () => {
    if (title.trim() !== "") {
      setLoading(true);
      try {
        const response = await fetch(`https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=searchshows&id_token=${idToken}&type=${type}&title=${title}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        if (data.status !== 'success') {
          throw new Error('Api error');
        }
        setResults(data.content ? data.content : []);
      } catch (error) {
        setResults([]); 
        console.error('Error fetching recommendations:', error);
      } finally {
        setLoading(false);
      }
    } else {
      alert("Por favor ingresa un título de película o serie.");
    }
  };

  const doHandleReview = async (recommendation, uniqueId) => {
    const reviewHandled = await handleReview(recommendation, uniqueId);
    if(reviewHandled){
      alert('Reseña enviada correctamente');
      setTitle('');
      setResults(null);
      setSelectedIndex(0);
    }else{
      alert('Hubo un error al enviar la reseña');
    }
  };

  const handlePrevious = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : results.length - 1
    );
  };

  const handleNext = () => {
    setSelectedIndex((prevIndex) => (prevIndex + 1) % results.length);
  };

  const isFirst = selectedIndex === 0;
  const isLast = selectedIndex === (results?.length ?? 0) - 1; 

  return (
    <Container maxWidth="md" sx={{padding:2}}>
      <Box my={4}>
          <Typography variant="h5" gutterBottom align='center'>
            ¿Qué te gustaría recomendar?
          </Typography>
        </Box>

      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <TextField
            select
            label="Tipo"
            value={type}
            onChange={(e) => setType(e.target.value)}
            fullWidth
            variant="outlined"
          >
            <MenuItem value="movie">Película</MenuItem>
            <MenuItem value="tv">Serie</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Título"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="error"
            onClick={handleSearch}
            disabled={loading}
            fullWidth
            style={{ borderRadius: '20px', padding: '10px 20px', fontSize: '1rem' }}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>

      {loading && <Loader/>}

      {results !== null && results.length === 0 && (
        <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
          <Paper elevation={0} style={{ padding: '20px', textAlign: 'center' }}>
            <SentimentDissatisfiedRoundedIcon style={{ fontSize: 48, color: 'gray' }} />
            <Typography variant="body1" style={{ marginTop: '16px' }}>
              No hay contenido que coincida con tu búsqueda.
            </Typography>
          </Paper>
        </Grid>
      )}

      {results && results.length > 0 && (
        <ShowCard
          show={results[selectedIndex]}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          reviewLoading={reviewLoading}
          handleReview={doHandleReview}
          canGoPrevious={!isFirst}
          canGoNext={!isLast}
        />
      )}
    </Container>
  );
};

export default AddReview;
